import { useState, useEffect } from "react"
import { apiJSONURL } from "../../App"

const dataUrl = process.env.REACT_APP_DATA_JSON_URL

export default function useWithdrawalForm({ username, type }) {
  const [otp, setOtp] = useState("")
  const [number, setNumber] = useState("")
  const [name, setName] = useState("")
  const [bank, setBank] = useState("")
  const [ewallet, setEWallet] = useState("")
  const [otpSent, setOtpSent] = useState(false)
  const [otpDisabled, setOtpDisabled] = useState(false)
  const [otpTimer, setOtpTimer] = useState(0)
  const [walletAddress, setWalletAddress] = useState("")

  const [submitting, setSubmitting] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")
  const [successMessage, setSuccessMessage] = useState("")
  const [saveDefault, setSaveDefault] = useState(0)

  const setDefaultFromServer = (value) => {
    setSaveDefault(value ? 1 : 0)
  }

  /* ---------------- OTP ---------------- */
  const getOTP = async (mobile) => {
    setOtpDisabled(true)
    setOtpTimer(30)

    const formData = new URLSearchParams({
      mobile,
      cmd: "getOTP",
    })

    try {
      const res = await fetch(dataUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
        body: formData.toString(),
      })

      const data = await res.json()
      setOtpSent(String(data.otp))
    } catch {
      setOtpDisabled(false)
    }
  }

  /* ---------------- TIMER ---------------- */
  useEffect(() => {
    if (otpTimer <= 0) return
    const t = setInterval(() => setOtpTimer((p) => p - 1), 1000)
    return () => clearInterval(t)
  }, [otpTimer])

  useEffect(() => {
    if (otpTimer === 0) setOtpDisabled(false)
  }, [otpTimer])

  /* ---------------- SUBMIT ---------------- */
  const submit = async ({ name, value, status, successText }) => {
    setErrorMessage("")

    const isNameEmpty = !name || name.trim() === ""
    const isValueEmpty = !value || value.trim() === ""
    const isOtpEmpty = !otp || otp.trim() === ""

    // 🔥 If all required inputs are empty
    if (isNameEmpty && isValueEmpty && isOtpEmpty) {
      return setErrorMessage("All fields are required")
    }

    // Keep your custom messages
    if (isNameEmpty) return setErrorMessage("Full name is required")
    if (isValueEmpty) {
      return setErrorMessage(
        type === "crypto"
          ? "Wallet address is required"
          : "Account number is required"
      )
    }

    if (!otpSent) return setErrorMessage("Please send OTP first")

    try {
      setSubmitting(true)

      const formData = new URLSearchParams({
        cmd: "saveWithdrawalAccount",
        u: username,
        type,
        mac: value,
        man: name,
        status,
        isDefault: saveDefault,
        otp,
      })

      const res = await fetch(apiJSONURL, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
        body: formData.toString(),
      })

      const data = await res.json()

      if (data?.e) return setErrorMessage(data.e)

      setSuccessMessage(successText || "Account connected successfully!")
      setOtp("")
      setNumber("")
      setName("")
      setBank("")
      setWalletAddress("")
      setOtpSent(false)
    } catch {
      setErrorMessage("Something went wrong")
    } finally {
      setSubmitting(false)
    }
  }

  useEffect(() => {
    if (!errorMessage) return

    const timer = setTimeout(() => {
      setErrorMessage("")
      setSuccessMessage("")
    }, 6000)

    return () => clearTimeout(timer)
  }, [errorMessage])

  useEffect(() => {
    if (!successMessage) return

    const timer = setTimeout(() => {
      setSuccessMessage("")
    }, 6000)

    return () => clearTimeout(timer)
  }, [successMessage])
  return {
    otp,
    setOtp,
    number,
    setNumber,
    name,
    setName,
    bank,
    setBank,
    walletAddress,
    setWalletAddress,
    ewallet,
    setEWallet,
    otpDisabled,
    otpTimer,
    submitting,
    errorMessage,
    successMessage,
    saveDefault,
    setSaveDefault,
    setDefaultFromServer,
    getOTP,
    submit,
  }
}
